export default __webpack_public_path__ + "static/media/learnSignup.92cf5cc8.JPG";